<script lang="ts">
  import { updateMeta, injectJsonLd } from "../seo/meta";
  import { ROUTE_SEO } from "../seo/routes";
  import { ORGANIZATION_SCHEMA, combineSchemas, getBreadcrumbSchema } from "../seo/schemas";
  updateMeta(ROUTE_SEO["/products/sailfish/docs"]);
  injectJsonLd(combineSchemas(
    ORGANIZATION_SCHEMA,
    getBreadcrumbSchema([
      { name: "Home", url: "https://0xfire.com/" },
      { name: "Sailfish", url: "https://0xfire.com/products/sailfish" },
      { name: "Docs", url: "https://0xfire.com/products/sailfish/docs" },
    ]),
  ));
  import {
    Info,
    Database,
    BookOpen,
    Link2,
    Box,
    Braces,
    Radio,
    Code,
  } from "lucide-svelte";
  import { html as Introduction } from "./docs/Introduction.md";
  import { html as Solana } from "./docs/Solana.md";
  import { html as Endpoints } from "./docs/Endpoints.md";
  import { html as Schema } from "./docs/Schema.md";
  import { html as SDK } from "./docs/SDK.md";

  let selectedSection = $state("Introduction");

  const sections = {
    Introduction: Introduction,
    Solana: Solana,
    Endpoints: Endpoints,
    Schema: Schema,
    SDK: SDK,
  };

  const getSectionContent = (section: string) => {
    return sections[section as keyof typeof sections];
  };
</script>

<div class="min-h-screen bg-black text-gray-300 selection:bg-orange-900 selection:text-white">
  <div class="drawer lg:drawer-open mb-16">
    <input id="my-drawer-4" type="checkbox" checked class="drawer-toggle" />
    <div class="drawer-content px-8 py-4">
      <article class="prose prose-sm prose-invert max-w-none">
        {@html getSectionContent(selectedSection)}
      </article>
    </div>

    <!-- SIDEBAR -->
    <div
      class="drawer-side z-40 hidden md:block"
      style="scroll-behavior: smooth; scroll-padding-top: 5rem;"
    >
      <label for="drawer" class="drawer-overlay"></label>
      <aside class="min-h-screen bg-gray-950/60 border-r border-gray-800">
        <ul class="menu p-4 w-100 text-gray-400">
          <li>
            <details id="disclosure-docs">
              <summary class="group hover:text-white">
                <span><BookOpen class="size-4" /></span> Overview
              </summary>
            </details>
            <ul>
              <li>
                <button
                  onclick={() => (selectedSection = "Introduction")}
                  class="group hover:text-white {selectedSection === 'Introduction' ? 'text-orange-500' : ''}"
                >
                  <span><Info class="size-4" /></span> Introduction
                </button>
              </li>
              <li>
                <button
                  onclick={() => (selectedSection = "Endpoints")}
                  class="group hover:text-white {selectedSection === 'Endpoints' ? 'text-orange-500' : ''}"
                >
                  <span><Link2 class="size-4" /></span> Endpoints
                </button>
              </li>
            </ul>
          </li>
          <li>
            <details id="disclosure-docs">
              <summary class="group hover:text-white">
                <span><Database class="size-4" /></span> Chains & Protocols
              </summary>
              <ul>
                <li>
                  <button
                    onclick={() => (selectedSection = "Solana")}
                    class="group hover:text-white {selectedSection === 'Solana' ? 'text-orange-500' : ''}"
                  >
                    <span><Box class="size-4" /></span> Solana
                  </button>
                </li>
              </ul>
            </details>
          </li>
          <li>
            <details id="disclosure-docs">
              <summary class="group hover:text-white">
                <span><Radio class="size-4" /></span> Websocket & API
              </summary>
              <ul>
                <li>
                  <button
                    onclick={() => (selectedSection = "Schema")}
                    class="group hover:text-white {selectedSection === 'Schema' ? 'text-orange-500' : ''}"
                  >
                    <span><Braces class="size-4" /></span> Schema
                  </button>
                </li>
                <li>
                  <button onclick={() => (selectedSection = "SDK")} class="group hover:text-white {selectedSection === 'SDK' ? 'text-orange-500' : ''}">
                    <span><Code class="size-4" /></span> Sailfish SDK
                  </button>
                </li>
              </ul>
            </details>
          </li>
        </ul>
      </aside>
    </div>
  </div>
</div>
